<div class="language-locales-container">
  <div class="header">
    <h2>Language-Locales Management</h2>
    <p-button
      icon="pi pi-plus"
      label="Add"
      severity="primary"
      (click)="onAddClick()"
      [disabled]="isLoading">
    </p-button>
  </div>

  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
      <p>Loading language-locales...</p>
    </div>
  } @else {
    <div class="filter-container">
      <div class="search-input-wrapper">
        <i class="pi pi-search search-icon"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchQuery"
          placeholder="Search by language or locale..."
          class="search-input" />
      </div>
    </div>

    <div class="table-container">
      <p-table [value]="filteredLanguageLocales" styleClass="language-locales-table">
        <ng-template pTemplate="header">
          <tr>
            <th>Language</th>
            <th>Locale</th>
            <th class="hide-mobile">Default TTS Model</th>
            <th class="hide-mobile" style="width: 8rem; text-align: center;">Active</th>
            <th style="width: 6rem; text-align: center;">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-languageLocale>
          <tr>
            <td>{{ languageLocale.language_name || '-' }}</td>
            <td>
              <span class="locale-desktop">{{ languageLocale.locale_flag || '' }} {{ languageLocale.locale_name || '-' }}</span>
              <span class="locale-mobile">{{ languageLocale.locale_flag || '-' }}</span>
            </td>
            <td class="hide-mobile">{{ getTtsModelName(languageLocale.default_tts_version_id) }}</td>
            <td class="hide-mobile" style="text-align: center;">
              <p-message
                [severity]="languageLocale.is_active ? 'success' : 'secondary'"
                [text]="languageLocale.is_active ? 'Active' : 'Inactive'"
                styleClass="status-message">
              </p-message>
            </td>
            <td style="text-align: center;">
              <p-button
                icon="pi pi-pencil"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                (click)="onEditClick(languageLocale)">
              </p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" style="text-align: center;">
              No language-locales found. Click "Add" to create one.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
